(() => {
  const node=document.querySelector('[data-sm-kit-navigation]');
  if(!node)return;
  const {path}=JSON.parse(node.textContent);
  if(!path)return;
  const variants={starter:'67600586866978',complete:'67600586998050'};
  const legacyVariants={'67519430951202':'67600586866978','67519433900322':'67600586899746','67519431147810':'67600586998050','67519434293538':'67600587063586','67519434326306':'67600587063586','67519434359074':'67600587030818','67519364628770':'67600586998050','67519366136098':'67600587063586','67519366168866':'67600587063586','67519366201634':'67600587030818'};
  const nativeIds=new Set(['67600586866978','67600586899746','67600586866978','67600586899746','67600586998050','67600587030818','67600587063586','67600586998050','67600587030818','67600587063586']);
  const aliases=['/products/led-soft-bristle-electric-toothbrush','/products/smylume-four-kit-offers','/products/smylume-single-head-bundle','/products/smylume-double-head-bundle','/products/smylume-two-toothbrush-pack'];
  const normalize=anchor=>{
    const href=anchor.getAttribute('href');
    if(!href||href.startsWith('#'))return;
    let url;try{url=new URL(href,location.origin);}catch{return;}
    if(url.origin!==location.origin)return;
    const alias=aliases.find(value=>url.pathname.endsWith(value));
    if(!alias)return;
    const prefix=url.pathname.slice(0,-alias.length);
    const explicit=({starterPlus:'starter',completePlus:'complete'})[url.searchParams.get('kit')]||url.searchParams.get('kit');
    const removed={'67600586932514':'67600586866978','67600586965282':'67600586899746','67600587096354':'67600586998050','67600587129122':'67600587030818','67600587161890':'67600587063586'};
    const previous=removed[url.searchParams.get('variant')]||url.searchParams.get('variant');
    if(removed[url.searchParams.get('variant')])url.searchParams.set('variant',previous);
    const fallback=alias.endsWith('smylume-single-head-bundle')?'starter':alias.endsWith('smylume-double-head-bundle')?'complete':'complete';
    const key=Object.hasOwn(variants,explicit)?explicit:fallback;
    url.searchParams.delete('preview_theme_id');
    url.pathname=path.startsWith(prefix+'/products/')?path:prefix+path;
    if(!nativeIds.has(previous)){
      const chosen=!Object.hasOwn(variants,explicit)&&legacyVariants[previous]?legacyVariants[previous]:previous==='67457041563938'?{starter:'67600586899746',starterPlus:'67600586899746',complete:'67600587030818',completePlus:'67600587030818'}[key]:variants[key];
      url.searchParams.set('variant',chosen);
      if(!legacyVariants[previous]||Object.hasOwn(variants,explicit))url.searchParams.set('kit',key);else url.searchParams.delete('kit');
    }
    if(explicit)url.searchParams.set('kit',explicit);
    anchor.setAttribute('href',url.pathname+url.search+url.hash);
  };
  document.querySelectorAll('a[href]').forEach(normalize);
  document.addEventListener('click',event=>{const anchor=event.target.closest('a[href]');if(anchor)normalize(anchor);},true);
})();

